import { randomBytes } from 'node:crypto';
import type { AppDirectClient } from '../client.js';
import { buildStateCookie } from '../session/cookies.js';
import type { LoginRedirectResult, ResolvedConfig } from '../types.js';

export function buildLoginRedirect(
  config: ResolvedConfig,
  client: AppDirectClient,
): LoginRedirectResult {
  const state = randomBytes(16).toString('hex');
  const authorizeUrl = client.buildAuthorizeUrl(state);

  return {
    authorizeUrl,
    state,
    cookiesToSet: [buildStateCookie(config, state)],
  };
}
